export default __webpack_public_path__ + "static/media/hint.cb507bd5.svg";